import React from 'react';
import { Switch, Route, Link, useHistory, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getInstitution } from '../../config/institutionConfig';
import AdminPublicaciones from './AdminPublicaciones';
import AdminPublicacionForm from './AdminPublicacionForm';
import AdminCategorias from './AdminCategorias';
import AdminCategoriaForm from './AdminCategoriaForm';

const AdminLayout = () => {
  const { usuario, logout } = useAuth();
  const history = useHistory();
  const location = useLocation();
  const institution = getInstitution();
  const colors = institution.colors;

  const handleLogout = () => {
    logout();
    history.replace('/admin/login');
  };

  const enCategorias = location.pathname.startsWith('/admin/categorias');
  const tabClass = (activa) =>
    `inline-block px-1 pb-3 text-sm font-medium border-b-2 transition-colors ${
      activa ? 'text-gray-900' : 'text-gray-500 border-transparent hover:text-gray-700'
    }`;

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Barra superior */}
      <header
        className="shadow-md"
        style={{
          background: `linear-gradient(135deg, ${colors.headerGradientStart}, ${colors.headerGradientMid}, ${colors.headerGradientEnd})`,
        }}
      >
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
          <Link to="/admin" className="flex items-center gap-3">
            <img
              src={`${process.env.PUBLIC_URL}${institution.logo}`}
              alt={`Logo ${institution.shortName}`}
              className="h-9"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <span className="text-white font-bold text-lg hidden sm:block">
              Administración · {institution.shortName}
            </span>
          </Link>

          <div className="flex items-center gap-4">
            <span className="text-white/85 text-sm hidden sm:block">
              {usuario?.nombre || usuario?.email}
            </span>
            <button
              onClick={handleLogout}
              className="text-sm font-medium text-white bg-white/15 hover:bg-white/25 border border-white/20 rounded-lg px-3 py-1.5 transition-colors"
            >
              Cerrar sesión
            </button>
          </div>
        </div>
      </header>

      {/* Pestañas de navegación */}
      <nav className="bg-white border-b border-gray-200">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 pt-3 flex gap-6">
          <Link
            to="/admin"
            className={tabClass(!enCategorias)}
            style={!enCategorias ? { borderBottomColor: colors.primary } : undefined}
          >
            Publicaciones
          </Link>
          <Link
            to="/admin/categorias"
            className={tabClass(enCategorias)}
            style={enCategorias ? { borderBottomColor: colors.primary } : undefined}
          >
            Categorías
          </Link>
        </div>
      </nav>

      {/* Contenido */}
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
        <Switch>
          <Route exact path="/admin" component={AdminPublicaciones} />
          <Route exact path="/admin/categorias" component={AdminCategorias} />
          <Route exact path="/admin/categorias/nueva" component={AdminCategoriaForm} />
          <Route exact path="/admin/categorias/:id/editar" component={AdminCategoriaForm} />
          <Route exact path="/admin/publicaciones/nueva" component={AdminPublicacionForm} />
          <Route exact path="/admin/publicaciones/:id/editar" component={AdminPublicacionForm} />
        </Switch>
      </main>
    </div>
  );
};

export default AdminLayout;
